import React from 'react';

const IconArrow = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0H20V20H0z" transform="translate(-5 -7)" />
      <path fill={color} fillRule="nonzero" d="M6.767 7.742L10 10.975l3.233-3.233c.325-.325.85-.325 1.175 0 .325.325.325.85 0 1.175l-3.825 3.825c-.325.325-.85.325-1.175 0L5.583 8.917c-.325-.325-.325-.85 0-1.175.325-.317.859-.325 1.184 0z" transform="translate(-5 -7)" />
    </g>
  </svg>
);

export default IconArrow;
